import { qs, qsa } from "./utils"

export const initAgendaAccordion = () => {
  const headers = qsa(".agenda__accordion-header")

  for (const header of headers) {
    header.addEventListener("click", () => {
      toggleAccordionGroup(header)
    })
    header.addEventListener("keypress", (e) => {
      if (["Space", "Enter"].includes(e.code)) {
        e.preventDefault()
        toggleAccordionGroup(header)
      }
    })
  }
}

/**
 * Toggle the display of all accordion content rows following the clicked header and update the <th> rowspan attribute.
 * @param {HTMLElement} header The accordion header row that was clicked.
 */
const toggleAccordionGroup = (header) => {
  // Toggle open state of the header
  const isExpanded = header.classList.toggle("open")

  // Find the <th> element with class "agenda__day" within the header
  const th = qs("th.agenda__day", header)
  if (th) {
    if (isExpanded) {
      // When expanded, set the rowspan attribute from the header's data-rowspan value
      th.setAttribute("rowspan", header.getAttribute("data-rowspan"))
      th.removeAttribute("colspan")
    } else {
      // When collapsed, remove the rowspan attribute
      th.removeAttribute("rowspan")
      th.setAttribute("colspan", header.getAttribute("data-colspan"))
    }
  }

  let nextRow = header.nextElementSibling
  // Continue until the next header row or end of table is reached
  while (nextRow && !nextRow.classList.contains("agenda__accordion-header")) {
    if (isExpanded) {
      nextRow.classList.add("show")
    } else {
      nextRow.classList.remove("show")
    }

    nextRow = nextRow.nextElementSibling
  }
}

// Attach event listeners to each accordion header row
